module.exports = __webpack_public_path__ + "img/WeChat-Moment-Adverts.0b9d1005.png";